<template>
  <div class="card dashboard-widget rating-widget">
    <div class="card-header">ALL TIME RATING</div>
    <div class="card-body">
        <div class="d-flex flex-column align-items-center">
            <div class="ratings-averages mb-1">
              <span v-if="summaryBar && summaryBar.average_score">
              <span class="ratings-averages-display mr-1">
                {{ summaryBar.average_score.toFixed(2) }}
              </span>
              out of {{ maxRating }}
              </span>
              <h2 v-else class="mr-1">No rating</h2>
                <!-- <span class="ratings-averages-display mr-1">{{ summaryData.average_score ? summaryData.average_score.toFixed(2) : null }}</span> out of {{ maxRating }} -->
            </div>
            <div class="ratings-star mb-3">
                <span class="badge badge-pill badge-light">
                    <b-rate
                        v-model="summaryBar.average_score"
                        :max="maxRating"
                        :size="sizes"
                        :icon-pack="packs"
                        :icon="icons"
                        :spaced="isSpaced"
                        :disabled="isDisabled">
                    </b-rate>
                </span>
            </div>
            <div class="total-user mb-2">
                <i class="fas fa-user-alt mr-1"></i>
                <span>{{ summaryBar.total }} Total</span>
            </div>
            <div class="total-user mb-2">
                <span>Rated {{ summaryBar.surveyed }} | Unrated {{ summaryBar.unsurveyed }}</span>
            </div>
        </div>
        <div class="ratings-bar col-12 mt-2">
            <div class="row ratings-bar-body mb-2" v-for="[key, value] of Object.entries(surveyedStat)" :key="key">
                <div class="ratings-bar-display-name col-sm-2 col-md-2">{{ key }}</div>
                <div class="col-sm-8 col-md-8 pt-1">
                    <b-progress :value="((value / summaryBar.surveyed) * 100 ) || 0" show-value format="percent" type="is-success"></b-progress>
                </div>
                <div class="ratings-bar-display-count col-sm-2 col-md-2">
                    {{ value }}
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import alice from '../../alice-api';


export default {
  name: 'rating-widget',
  components: {
  },
  props: {
    summaryData: {
      type: Object,
      default: () => {},
    },
    channelFilter: {
      type: String,
      default: 'all'
    },
    selectedDate: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      statNameMap: {
        very_satisfied: 'Excellent',
        satisfied: 'Good',
        ok: 'Fair',
        dissatisfied: 'Poor',
        very_dissatisfied: 'Very poor',
      },

      // b-rate
      maxRating: 5,
      sizes: 'is-medium',
      packs: 'fas',
      icons: 'star',
      isSpaced: true,
      isDisabled: true,

      summaryWithFilter: [],
    };
  },
  mounted() {
    this.initFilter();
  },
  watch: {
    channelFilter() {
      this.initFilter();
    },
    selectedDate() {
      this.initFilter();
    },
  },
  methods: {
    async initFilter() {
      // this.isLoading = true;
      const filter = [];
      if (this.channelFilter && this.channelFilter !== 'all') {
        filter.push({
          field: 'channel',
          value: [
            this.channelFilter,
          ],
        });
      }
      this.getSummaryWithFilter(filter);
      // this.isLoading = false;
    },
    async getSummaryWithFilter(filter) {
      const result = await alice.getFormSummaryWithFilter({
        filter,
        dateFilter: {
          from: this.selectedDate.from,
          to: this.selectedDate.to,
        },
        onlySurvey: false,
      });

      if (result && result.data && result.data.data) {
        const { data } = result.data;
        this.summaryWithFilter = data;
      }
    },
  },
  computed: {
    summaryDataBar() {
      if (this.summaryData && this.summaryData.surveyed_stat) {
        let convertNameStat = {};
        for (const key in this.summaryData.surveyed_stat) {
          if (this.statNameMap[key]) {
            convertNameStat = {
              ...convertNameStat,
              [this.statNameMap[key]]: this.summaryData.surveyed_stat[key],
            };
          }
        }
        return convertNameStat;
      }
      return {};
    },
    surveyedStat() {
      if (this.summaryWithFilter && this.summaryWithFilter.surveyed_stat) {
        const statNameMap = {
          very_satisfied: 'Excellent (5)',
          satisfied: 'Good (4)',
          ok: 'Fair (3)',
          dissatisfied: 'Poor (2)',
          very_dissatisfied: 'Very poor (1)',
        };

        let convertNameStat = {};
        for (const key in this.summaryWithFilter.surveyed_stat) {
          if (statNameMap[key]) {
            convertNameStat = {
              ...convertNameStat,
              [statNameMap[key]]: this.summaryWithFilter.surveyed_stat[key],
            };
          }
        }
        return convertNameStat;
      }
      return {};
    },
    summaryBar() {
      if (this.summaryWithFilter) {
        return this.summaryWithFilter;
      }
      return {};
    },
  },

};
</script>

<style lang="scss" scoped>
.rating-widget {
  .card-body {
    padding-bottom: 1rem;
    .ratings-averages {
        .ratings-averages-display {
            line-height: 43px;
            font-size: 50px;
            font-weight: 700;
            letter-spacing: -.07em;
            color: #4c4c50;
            margin-right: 3px;
        }
    }
    @media only screen and (min-width: 735px) {
        .ratings-averages-display {
            margin-bottom: 0;
            display: inline-block;
        }
    }
    .ratings-star {
       .badge {
          font-size: 100% !important;
        }
    }
    .total-user {
        text-align: right;
        color: #636366;
        font-size: 14px;
        line-height: 1.38462;
        font-weight: 400;
        letter-spacing: -.005em;
    }
    .ratings-bar {
        .ratings-bar-body {
            .ratings-bar-display-name {
                text-align: end;
            }
            .ratings-bar-display-count {
                font-size: 1rem;
                text-align: start;
            }
            @media only screen and (max-width: 575px) {
                .ratings-bar-display-name {
                    text-align: start;
                    margin-top: 2px;
                }
                .ratings-bar-display-count {
                    display: none;
                }
            }
            @media only screen and (max-width: 1300px) and (min-width: 765px) {
                .ratings-bar-display-name {
                    text-align: end;
                    margin-top: 2px;
                    white-space: nowrap;
                    width: 50px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
        }
    }
  }
}
</style>
